<!-- Start Training Page Section -->
<main class="ecb-web-training-page">

    <!-- Start Training Banner Section -->
    <section class="ecb-web-training-banner-section">

        <!-- Start Training Banner Overlay Section -->
        <div class="ecb-web-training-banner-overlay"></div>
        <!-- End Training Banner Overlay Section -->

        <div class="container ecb-web-training-banner-container">
            <div class="row align-items-center">

                <!-- Start Training Banner Content Section -->
                <div class="col-12 col-lg-6">
                    <div class="ecb-web-training-banner-content">

                        <h1>Training Courses</h1>

                        <h2>Build skills. Gain confidence. Save lives.</h2>

                        <p>
                            ECB Training offers nationally recognised courses designed
                            to equip you with the knowledge and practical skills to
                            respond in real-life situations.
                        </p>

                        <!-- Start Training Banner Feature Section -->
                        <div class="ecb-web-training-banner-features">

                            <div class="ecb-web-training-banner-feature">
                                <i class="bi bi-patch-check-fill"></i>

                                <span>
                                    Nationally<br>
                                    Recognised
                                </span>
                            </div>

                            <div class="ecb-web-training-banner-feature">
                                <i class="bi bi-people"></i>

                                <span>
                                    Experienced<br>
                                    Trainers
                                </span>
                            </div>

                            <div class="ecb-web-training-banner-feature">
                                <i class="bi bi-person-arms-up"></i>

                                <span>
                                    Hands-on<br>
                                    Learning
                                </span>
                            </div>

                        </div>
                        <!-- End Training Banner Feature Section -->

                    </div>
                </div>
                <!-- End Training Banner Content Section -->

            </div>
        </div>

    </section>
    <!-- End Training Banner Section -->

 


    <!-- Start Training Category Section -->
    <section class="ecb-web-training-category-section">
        <div class="container">

            <!-- Start Training Category Heading Section -->
            <div class="ecb-web-training-section-heading">

                <h2>  Our
                    <span>Training Courses</span>
                </h2>

                <p>
                    Choose from a wide range of nationally recognised training
                    courses delivered by industry experts.
                </p>

            </div>
            <!-- End Training Category Heading Section -->


            <!-- Start Training Category Card Section -->
            <div class="ecb-web-training-category-grid">

                <article class="ecb-web-training-category-card" *ngFor="
            let category of trainingCategories;
            trackBy: trackById
          ">

                    <!-- Start Training Category Icon Section -->
                    <div class="ecb-web-training-category-icon" [ngClass]="category.colorClass">
                        <i [class]="category.icon"></i>
                    </div>
                    <!-- End Training Category Icon Section -->

                    <h3>{{ category.name }}</h3>

                    <p>{{ category.description }}</p>

                    <a [href]="category.route">
                        View Courses

                        <i class="bi bi-arrow-right"></i>
                    </a>

                </article>

            </div>
            <!-- End Training Category Card Section -->

        </div>
    </section>
    <!-- End Training Category Section -->


    <!-- Start Featured Course Section -->
    <section id="featured-courses" class="ecb-web-featured-course-section">
        <div class="container">

            <!-- Start Featured Course Heading Section -->
            <div class="ecb-web-featured-course-heading">

                <h2>Featured Courses</h2>

                <a href="#" class="btn ecb-web-featured-view-all-button">
                    View All Courses
                </a>

            </div>
            <!-- End Featured Course Heading Section -->


            <!-- Start Featured Course Card Section -->
            <div class="row g-4 row-cols-1 row-cols-sm-2 row-cols-xl-4">

                <div class="col" *ngFor="
            let course of featuredCourses;
            trackBy: trackById
          ">
                    <article class="ecb-web-featured-course-card">

                        <!-- Start Featured Course Image Section -->
                        <div class="ecb-web-featured-course-image-wrapper">

                            <img [src]="course.image" [alt]="course.title" class="ecb-web-featured-course-image">

                        </div>
                        <!-- End Featured Course Image Section -->


                        <!-- Start Featured Course Content Section -->
                        <div class="ecb-web-featured-course-body">

                            <span class="ecb-web-featured-course-code">
                                {{ course.courseCode }}
                            </span>

                            <h3>{{ course.title }}</h3>

                            <!-- Start Featured Course Detail Section -->
                            <div class="ecb-web-featured-course-details">

                                <span>
                                    <i class="bi bi-clock"></i>
                                    {{ course.duration }}
                                </span>

                                <span>
                                    <i class="bi bi-geo-alt"></i>
                                    {{ course.deliveryMethod }}
                                </span>

                            </div>
                            <!-- End Featured Course Detail Section -->

                            <p>{{ course.description }}</p>

                            <a [href]="course.route">
                                Learn More

                                <i class="bi bi-arrow-right"></i>
                            </a>

                        </div>
                        <!-- End Featured Course Content Section -->

                    </article>
                </div>

            </div>
            <!-- End Featured Course Card Section -->

        </div>
    </section>
    <!-- End Featured Course Section -->


    <!-- Start Training Process Section -->
    <section class="ecb-web-training-process-section">
        <div class="container">

            <!-- Start Training Process Heading Section -->
            <div class="ecb-web-training-section-heading">

                <h2>Our Training Process</h2>

                <p>
                    Training that is simple, effective and engaging.
                </p>

            </div>
            <!-- End Training Process Heading Section -->


            <!-- Start Training Process List Section -->
            <div class="ecb-web-training-process-list">

                <article class="ecb-web-training-process-card" *ngFor="
            let process of trainingProcesses;
            let lastProcess = last;
            trackBy: trackById
          ">

                    <!-- Start Training Process Connector Section -->
                    <div class="ecb-web-training-process-connector" *ngIf="!lastProcess"></div>
                    <!-- End Training Process Connector Section -->


                    <!-- Start Training Process Icon Section -->
                    <div class="ecb-web-training-process-icon" [ngClass]="process.colorClass">
                        <i [class]="process.icon"></i>
                    </div>
                    <!-- End Training Process Icon Section -->

                    <h3>
                        <span>{{ process.stepNumber }}.</span>
                        {{ process.title }}
                    </h3>

                    <p>{{ process.description }}</p>

                </article>

            </div>
            <!-- End Training Process List Section -->

        </div>
    </section>
    <!-- End Training Process Section -->


    <!-- Start Why Choose Training Section -->
    <section class="ecb-web-training-benefit-section">
        <div class="container">

            <div class="ecb-web-training-benefit-panel">

                <!-- Start Training Benefit Overlay Section -->
                <div class="ecb-web-training-benefit-overlay"></div>
                <!-- End Training Benefit Overlay Section -->


                <!-- Start Training Benefit Content Section -->
                <div class="ecb-web-training-benefit-content">

                    <h2>Why Train With ECB Training?</h2>

                    <ul class="ecb-web-training-benefit-list">

                        <li *ngFor="
                let benefit of trainingBenefits;
                trackBy: trackById
              ">
                            <i class="bi bi-check-circle-fill"></i>

                            <span>{{ benefit.title }}</span>
                        </li>

                    </ul>

                </div>
                <!-- End Training Benefit Content Section -->

            </div>

        </div>
    </section>
    <!-- End Why Choose Training Section -->


    <!-- Start Student Testimonial Section -->
    <section class="ecb-web-training-testimonial-section">
        <div class="container">

            <!-- Start Student Testimonial Heading Section -->
            <div class="ecb-web-training-section-heading">

                <h2>What Our Students Say</h2>

            </div>
            <!-- End Student Testimonial Heading Section -->


            <!-- Start Student Testimonial Card Section -->
            <div class="row g-4 row-cols-1 row-cols-md-2 row-cols-xl-3">

                <div class="col" *ngFor="
            let testimonial of getDisplayedTestimonials();
            trackBy: trackById
          ">
                    <article class="ecb-web-training-testimonial-card">

                        <!-- Start Student Rating Section -->
                        <div class="ecb-web-training-testimonial-stars">

                            <i class="bi bi-star-fill" *ngFor="
                  let star of getRatingStars(testimonial.rating)
                "></i>

                        </div>
                        <!-- End Student Rating Section -->

                        <blockquote>
                            “{{ testimonial.message }}”
                        </blockquote>

                        <!-- Start Student Information Section -->
                        <div class="ecb-web-training-student-information">

                            <div>
                                <h3>{{ testimonial.studentName }}</h3>
                                <p>{{ testimonial.courseName }}</p>
                            </div>

                            <img [src]="testimonial.image" [alt]="testimonial.studentName"
                                class="ecb-web-training-student-image">

                        </div>
                        <!-- End Student Information Section -->

                    </article>
                </div>

            </div>
            <!-- End Student Testimonial Card Section -->


            <!-- Start Testimonial Pagination Section -->
            <div class="ecb-web-training-testimonial-pagination">

                <button type="button" *ngFor="
            let page of getTestimonialPageCount()
          " [class.ecb-web-training-testimonial-dot-active]="
            selectedTestimonialPage === page
          " [attr.aria-label]="'Show testimonial page ' + (page + 1)" (click)="selectTestimonialPage(page)"></button>

            </div>
            <!-- End Testimonial Pagination Section -->

        </div>
    </section>
    <!-- End Student Testimonial Section -->


    <!-- Start Training Call to Action Section -->
    <section class="ecb-web-training-cta-section">
        <div class="container">

            <div class="ecb-web-training-cta-panel">

                <!-- Start Training CTA Overlay Section -->
                <div class="ecb-web-training-cta-overlay"></div>
                <!-- End Training CTA Overlay Section -->

                <div class="row align-items-center g-4 position-relative">

                    <!-- Start Training CTA Content Section -->
                    <div class="col-12 col-lg-6">

                        <div class="ecb-web-training-cta-content">

                            <h2>Ready to Get Started?</h2>

                            <p>
                                Find the right course for you and start your training
                                journey today.
                            </p>

                        </div>

                    </div>
                    <!-- End Training CTA Content Section -->


                    <!-- Start Training CTA Button Section -->
                    <div class="col-12 col-lg-6">

                        <div class="ecb-web-training-cta-buttons">

                            <a href="#featured-courses" class="btn ecb-web-training-cta-primary-button">
                                Find a Course
                            </a>

                            <a routerLink="/contact" class="btn ecb-web-training-cta-secondary-button">
                                Contact Us
                            </a>

                        </div>

                    </div>
                    <!-- End Training CTA Button Section -->

                </div>

            </div>

        </div>
    </section>
    <!-- End Training Call to Action Section -->

</main>
<!-- End Training Page Section -->